import { IUserBase } from '../../models/users';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export type IUserGuestListItem = IUserBase;

export type IUserGuestList = IListResponse<IUserGuestListItem>;

interface IListUserGuestProps {
  cpf?: string;
  email?: string;
  groupKey: 'GUEST' | 'DEPENDANT';
  hostId: string;
  minExperience?: number;
  name?: string;
  phone?: string;
  sort?: 'cpf' | 'name' | 'phone' | 'email' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export const listUserGuestsService = async ({
  cpf,
  email,
  groupKey,
  hostId,
  minExperience,
  name,
  phone,
  sort,
  order,
  limit,
  page = 1,
}: IListUserGuestProps): Promise<IUserGuestList> => {
  const params = {
    cpf: cpf || undefined,
    email: email || undefined,
    groupKey,
    minExperience: minExperience || undefined,
    name: name || undefined,
    phone: phone || undefined,
    sort,
    order,
    limit,
    page,
  };

  const { data } = await jhsfBookingsApi.get<IUserGuestList>(
    `/v2/users/${hostId}/guests`,
    {
      params,
    },
  );

  return data;
};
